import axios, { type AxiosRequestConfig } from 'axios';
import qs from 'qs';
import {
  addAuthorizationHeader,
  addMetrics,
  defaultsInterceptor,
  normalizeParams,
} from './requestInterceptors';
import { errorResponse, successResponse } from './responseInterceptors';

const createInstance = (options: AxiosRequestConfig) => {
  const instance = axios.create(options);
  instance.interceptors.request.use(defaultsInterceptor);
  instance.interceptors.request.use(addAuthorizationHeader);
  instance.interceptors.request.use(normalizeParams);
  instance.interceptors.request.use(addMetrics);
  instance.interceptors.response.use(successResponse, errorResponse);

  return instance;
};

export const api = createInstance({
  withCredentials: false,
  paramsSerializer: {
    indexes: null,
    serialize: params => qs.stringify(params, { arrayFormat: 'comma' }),
  },
});
